<template>
  <div class="ipadStock">
    <van-notice-bar wrapable :scrollable="false" text="请核对信息，若有误请点击进行修改" />
    <ScanQR @scan="onScan" @input="onInput" :value="assetObj.serial" />

    <transition name="van-fade">
      <van-cell-group v-show="assetDetail" class="ipadStock-assetDetail" :border="false">
        <van-field label="iPad序列号" v-model="assetObj.serial" disabled />
        <van-field label="iPad型号" v-model="assetObj.model" disabled />
        <van-field label="资产状态" v-model="assetObj.Status" disabled />
        <van-field label="BU" v-model="assetObj.bu" disabled />
        <van-field v-model="assetObj.dept" label="部门" />
        <van-field v-model="assetObj.city" label="城市" />
        <van-field v-model="assetObj.chinese_name" label="姓名" />
        <van-field v-model="assetObj.phone" label="电话" />
        <van-field v-model="assetObj.email" label="达能邮箱" />
        <van-cell center :title="'是否为iPad实际使用人'">
          <template #right-icon>
            <van-switch v-model="sj_user" size="24" />
          </template>
        </van-cell>
      </van-cell-group>
    </transition>

    <van-divider content-position="left">iPad照片</van-divider>
    <span style="color:red;margin-left: 20px;">*</span>
    <ChooseImgs class="ipadStock-img" @finish="photo1" ref="chooseImg1" :stockType="stockType" />

    <van-switch-cell v-model="question" title="是否有疑问" />

    <van-field v-model="remark" clearable placeholder="请输入备注" label="备注"
      type="textarea" maxlength="200" autosize show-word-limit />

    <div class="ipadStock-submit">
      <van-button round type="primary" :loading="submitting" :loading-text="'提交中'" @click="onSubmit">
        提交 </van-button>
    </div>

  </div>
</template>

<script>
import {
  Button, Image, Field, Icon, Cell, CellGroup, Divider, SwitchCell, Switch, Toast, Dialog, NoticeBar
} from 'vant';
import { jsConfig } from '@/api/wx';
import ChooseImgs from '@/components/chooseImgs';
import ScanQR from '@/components/scanQR';

export default {
  components: {
    ScanQR, ChooseImgs,
    [Button.name]: Button, [Image.name]: Image, [Field.name]: Field, [Icon.name]: Icon,
    [CellGroup.name]: CellGroup, [Cell.name]: Cell, [Divider.name]: Divider,
    [SwitchCell.name]: SwitchCell, [Switch.name]: Switch, Toast, Dialog, [NoticeBar.name]: NoticeBar
  },

  data() {
    return {
      assetOld: {},
      assetObj: { picture: [] },
      assetNum: '',
      assetDetail: {},
      question: '',
      remark: '',
      loading: false,
      img1: '',
      stockType: '',
      address: '',
      submitting: false,
      sj_user: true
    };
  },

  methods: {
    onScan(val) {
      this.stockType = 'qrcode';
      this.getAsset('qrcode', val)
    },
    onInput(val) {
      this.stockType = 'input';
      this.getAsset('serial', val)
    },
    getAsset(type, value) {
      this.$refs.chooseImg1.refresh()
      this.$axios.get('ipad/query?type=' + type + '&value=' + encodeURIComponent(value)).then(res => {
        if (res.stock_status == '已盘点') {
          Toast('该资产已盘点完成');
        }
        this.assetObj = res
        this.sj_user = res.sj_user === '是'
        this.assetOld = {
          bu: res.bu,
          dept: res.dept,
          city: res.city,
          chinese_name: res.chinese_name,
          phone: res.phone,
          email: res.email,
          sj_user: res.sj_user,
          picture: res.picture
        }
        if(!res.picture) {
          this.assetOld.picture = []
          this.assetObj.picture = []
        }
      })
    },
    photo1(id) {
      this.assetObj.picture.push(id);
    },
    onSubmit() {
      if (!this.assetObj.id) {
        Toast('请输入需要盘点的资产');
        return;
      }
      if (this.question && !this.remark) {
        Toast('有疑问时，请输入备注');
        return;
      }
      let changeFields = Object.keys(this.assetOld).filter(item => {
        return this.assetOld[item] != this.assetObj[item]
      })
      const stock_question = (this.question || changeFields.length > 0 || this.remark) ? '1' : '0'

      if (this.stockType =='list' && this.assetObj.picture.length==0 ) {
        Toast('请按提示上传资产图片');
        return;
      }
      this.submitting = true;
      this.assetObj.picture = JSON.stringify(this.assetObj.picture);
      this.$axios.post('ipad/stock', {
        id: this.assetObj.id,
        stock_type: this.stockType,
        stock_pictures: this.img1,
        stock_question,
        change_field: changeFields.join(','),
        stock_comments: this.remark,
        stock_location: this.address,
        dept: this.assetObj.dept,
        city: this.assetObj.city,
        chinese_name: this.assetObj.chinese_name,
        phone: this.assetObj.phone,
        email: this.assetObj.email,
        sj_user: this.sj_user ? '是' : '否',
        picture: this.assetObj.picture
      }).then((number) => {
        const message = '当前iPad资产已完成盘点\n' + (number > 0 ? `您当前还有${number}个资产未盘点，请继续` : '');
        Dialog({
          title: '提交成功',
          message
        })
        this.submitting = false;
        this.assetObj = {},
          this.assetNum = '',
          this.assetDetail = {},
          this.question = '',
          this.remark = '',
          this.loading = false,
          this.img1 = '',
          this.stockType = ''
        this.assetObj.picture = []
        this.sj_user = false
        this.$refs.chooseImg1.refresh()
      }).catch(res => {
        Dialog({ message: '盘点失败\n' + res })
        this.submitting = false;
      })
    }
  },

  created() {
    let { id } = this.$route.query;
    if (id) {
      this.$nextTick(() => {
        this.stockType = "list";
        this.getAsset('id', id);
      })
    }
    this.$wx.ready(() => {
      this.$wx.getLocation({
        type: "wgs84",
        success: (res) => {
          this.$axios.get('wx/location?lat=' + res.latitude + '&lng=' + res.longitude)
            .then(addr => {
              Toast(addr ? '定位：' + addr : '定位异常');
              this.address = addr;
            })
        },
        fail() {
          Toast('定位失败');
        }
      });
    });
    jsConfig();
  }
};
</script>

<style lang="less">
.ipadStock {
  padding: 20px 0 50px 0;

  &-assetDetail {
    padding: 10px 20px;
  }

  &-img {
    margin-left: 20px;
  }

  &-submit {
    text-align: center;

    button {
      padding: 0 50px;
      margin: 20px auto;
    }
  }

}
</style>
